import httpClientGroups from '../api/httpClientGroups';

export const searchMembers = async (query) => {
  const response = await httpClientGroups.get(`/api/members/MemberManagement/Search/${encodeURIComponent(query)}`);
  return response.data;
};

export const getAllMembers = async ({ pageNumber = 1, pageSize = 10 }) => {
  const response = await httpClientGroups.get(`/api/members/MemberManagement/GetAll`, {
    params: { pageNumber, pageSize },
  });
  return response.data;
};

export const searchMembersWithSubMembers = async (keyword) => {
  const response = await httpClientGroups.get(`/api/members/MemberManagement/SearchWithSubMembers/${encodeURIComponent(keyword)}`);
  return response.data;
};

export const getMemberById = async (id) => {
  const response = await httpClientGroups.get(`/api/members/MemberManagement/GetById/${id}`);
  return response.data;
};

export const updateMember = async (payload) => {
  // payload should be a plain JSON object; backend expects fields like:
  // { id, firstName, lastName, phoneNumber, email, address, jobTitle, company, sector, university, highSchool, referenceMemberId, groupId }
  const response = await httpClientGroups.put('/api/members/MemberManagement/Update', payload);
  return response.data;
};

export const createMember = async (payload) => {
  // payload should contain fields and optional file
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (key === 'ProfilePicture' && value instanceof File) {
      formData.append('ProfilePicture', value, value.name);
    } else {
      formData.append(key, value);
    }
  });
  const response = await httpClientGroups.post('/api/members/MemberManagement/MemberCreate/MemberCreate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteMember = async (id) => {
  const response = await httpClientGroups.delete(`/api/members/MemberManagement/Delete/${id}`);
  return response.data;
};

export const addSubMember = async (payload) => {
  // expects keys: MemberId, FirstName, LastName, Email, PhoneNumber, JobTitle, Company, Sector, University, HighSchool, Address, Password (optional), ProfilePicture (File)
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (key === 'ProfilePicture' && value instanceof File) {
      formData.append('ProfilePicture', value, value.name);
    } else {
      formData.append(key, value);
    }
  });
  const response = await httpClientGroups.post('/api/members/MemberManagement/AddSubMember', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const removeSubMember = async (subMemberId) => {
  const response = await httpClientGroups.delete(`/api/members/MemberManagement/RemoveSubMember/${subMemberId}`);
  return response.data;
};

export const updateSubMember = async (payload) => {
  // payload: { id, firstName, lastName, phoneNumber, email, address, jobTitle, company, sector, university, highSchool }
  const response = await httpClientGroups.put('/api/members/MemberManagement/UpdateSubMember', payload);
  return response.data;
};

export const updateMemberProfilePicture = async ({ MemberId, ProfilePicture }) => {
  const formData = new FormData();
  if (MemberId) formData.append('MemberId', MemberId);
  if (ProfilePicture instanceof File) {
    formData.append('ProfilePicture', ProfilePicture, ProfilePicture.name);
  }
  const response = await httpClientGroups.put('/api/members/MemberManagement/UpdateMemberProfilePicture/ProfilePicture', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateSubMemberProfilePicture = async ({ SubMemberId, ProfilePicture }) => {
  const formData = new FormData();
  if (SubMemberId) formData.append('SubMemberId', SubMemberId);
  if (ProfilePicture instanceof File) formData.append('ProfilePicture', ProfilePicture, ProfilePicture.name);
  const response = await httpClientGroups.put('/api/members/MemberManagement/UpdateSubMemberProfilePicture/SubMemberProfilePicture', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getMemberChildren = async (memberId) => {
  const response = await httpClientGroups.get(`/api/members/MemberManagement/GetChildren/Children/${memberId}`);
  return response.data;
};

export const createMemberChild = async (payload) => {
  const response = await httpClientGroups.post('/api/members/MemberManagement/CreateChild/Children', payload);
  return response.data;
};

export const updateMemberChild = async (payload) => {
  const response = await httpClientGroups.put('/api/members/MemberManagement/UpdateChild/Children', payload);
  return response.data;
};

export const deleteMemberChild = async (childId) => {
  const response = await httpClientGroups.delete(`/api/members/MemberManagement/DeleteChild/Children/${childId}`);
  return response.data;
};

export const getAllUpdateRequests = async ({ pageNumber = 1, pageSize = 20, status = null }) => {
  const params = { pageNumber, pageSize };
  if (status !== null && status !== undefined) {
    params.status = status;
  }
  const response = await httpClientGroups.get('/api/members/MemberUpdateRequest/GetAll', {
    params,
  });
  return response.data;
};

export const getUpdateRequestById = async (requestId) => {
  const response = await httpClientGroups.get(`/api/members/MemberUpdateRequest/GetById/${requestId}`);
  return response.data;
};

export const approveUpdateRequest = async (requestId) => {
  const response = await httpClientGroups.post(`/api/members/MemberUpdateRequest/Approve/${requestId}/approve`);
  return response.data;
};

export const rejectUpdateRequest = async (requestId, rejectionReason) => {
  const response = await httpClientGroups.post(`/api/members/MemberUpdateRequest/Reject/${requestId}/reject`, {
    requestId,
    status: 2, // Rejected
    rejectionReason,
  });
  return response.data;
};

export const forceChangePassword = async (payload) => {
  const response = await httpClientGroups.put(
    '/api/members/MemberManagement/ForceChangePassword/ForceChangePassword',
    payload
  );
  return response.data;
};

export default {
  searchMembers,
  searchMembersWithSubMembers,
  getAllMembers,
  getMemberById,
  updateMember,
  createMember,
  deleteMember,
  addSubMember,
  removeSubMember,
  updateSubMember,
  updateMemberProfilePicture,
  updateSubMemberProfilePicture,
  getAllUpdateRequests,
  getUpdateRequestById,
  approveUpdateRequest,
  rejectUpdateRequest,
  forceChangePassword,
  getMemberChildren,
  createMemberChild,
  updateMemberChild,
  deleteMemberChild,
};


